// ═══════════════════════════════════════════════════════════════════
//  composants/BouxImg.js
//  BouxImg
// ═══════════════════════════════════════════════════════════════════

// ── Boux mascotte (GIF animé, réutilisable) ───────────────────────────
// Le fichier crystal_owl.gif doit être dans  public\crystal_owl.gif
export function BouxImg({ height, width }) {
  return (
    <>
      <style>{`@keyframes bouxFloat{0%,100%{transform:translateY(0)}50%{transform:translateY(-6px)}}`}</style>
      <img
        src="/crystal_owl.gif"
        alt="Boux"
        draggable={false}
        style={{
          height,
          width,
          imageRendering: "pixelated",
          filter: "drop-shadow(0 4px 8px rgba(124,58,237,0.4))",
          animation: "bouxFloat 3s ease-in-out infinite",
        }}
      />
    </>
  );
}
